/* Variateur de température de couleur — Plafonniers Design
   Modèle du projet : 2700 K ambre, 6500 K blanc très légèrement rosé.
   Jamais de bleu. Seule la teinte varie, jamais l'intensité :
   l'opacité des calques est constante sur toute la course. */
(function () {
  'use strict';

  var STOPS = [
    [2700, 255, 165, 79],
    [3000, 255, 180, 107],
    [4000, 255, 209, 168],
    [5000, 255, 228, 206],
    [6500, 254, 249, 255]
  ];

  function kToColor(k) {
    if (k <= STOPS[0][0]) return 'rgb(' + STOPS[0][1] + ',' + STOPS[0][2] + ',' + STOPS[0][3] + ')';
    for (var i = 1; i < STOPS.length; i++) {
      if (k <= STOPS[i][0]) {
        var a = STOPS[i - 1], b = STOPS[i];
        var t = (k - a[0]) / (b[0] - a[0]);
        return 'rgb(' +
          Math.round(a[1] + (b[1] - a[1]) * t) + ',' +
          Math.round(a[2] + (b[2] - a[2]) * t) + ',' +
          Math.round(a[3] + (b[3] - a[3]) * t) + ')';
      }
    }
    var l = STOPS[STOPS.length - 1];
    return 'rgb(' + l[1] + ',' + l[2] + ',' + l[3] + ')';
  }

  function kToName(k) {
    if (k < 3000) return 'Chaleureuse';
    if (k < 3600) return 'Blanc chaud';
    if (k < 4600) return 'Neutre';
    if (k < 5600) return 'Blanc froid';
    return 'Lumière du jour';
  }

  function apply(scope, k) {
    scope.style.setProperty('--kcol', kToColor(k));
    var outs = scope.querySelectorAll('[data-pd-k-out]');
    for (var i = 0; i < outs.length; i++) outs[i].innerHTML = k + '<small> K</small>';
    var names = scope.querySelectorAll('[data-pd-k-name]');
    for (var j = 0; j < names.length; j++) names[j].textContent = kToName(k);
    var rs = scope.querySelectorAll('[data-pd-kr]');
    for (var n = 0; n < rs.length; n++) if (rs[n].value != k) rs[n].value = k;
  }

  /* un seul écouteur sur le document : survit au rechargement de section
     de l'éditeur de thème, contrairement à un écouteur par élément */
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-pd-kr')) return;
    var scope = t.closest('[data-pd-dim]');
    if (scope) apply(scope, parseInt(t.value, 10));
  });

  /* changement de visuel principal */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-pd-thumb]') : null;
    if (!btn) return;
    var scope = btn.closest('[data-pd-dim]');
    if (!scope) return;
    var main = scope.querySelector('[data-pd-main] img');
    var src = btn.getAttribute('data-pd-thumb');
    if (main && src) {
      main.setAttribute('src', src);
      main.removeAttribute('srcset');
    }
    var all = scope.querySelectorAll('[data-pd-thumb]');
    for (var i = 0; i < all.length; i++) all[i].setAttribute('aria-current', String(all[i] === btn));
  });

  function init() {
    var scopes = document.querySelectorAll('[data-pd-dim]');
    for (var i = 0; i < scopes.length; i++) {
      var r = scopes[i].querySelector('[data-pd-kr]');
      apply(scopes[i], r ? parseInt(r.value, 10) : 4000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* l'éditeur de thème recharge les sections sans recharger la page */
  document.addEventListener('shopify:section:load', init);
})();